import React, {Component} from 'react';
import { Link } from "react-router-dom";
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";

//import Notification from "../component/Notification";
import ProfileMenu from "../component/ProfileMenu";


//import logo from "";

class Header extends Component {
	constructor(props) {
        super(props);
        this.state={
            isReady:false,
            isLogout:false,
        }
    }

    componentDidMount() {
        if(!this.state.isReady){
            this.setState({
                isReady:true
            });
        }
    }

    render() {
        return(
        	<React.Fragment>
        		<header id="page-topbar" className='bg-primary'>
                    <div className="navbar-header">
                        <div className="d-flex">
                            <div className="navbar-brand">
                                <Link to="/" className="logo logo-dark">
                                  <span className="logo-sm">
                                    {/*<img src={logo} alt="" height="90" />*/}
        </span>
                                  <span className="logo-lg">
                                    {/*<img src={logo} alt="" height="90" />*/}
                                  </span>
                                </Link>
                                <Link to="/" className="logo logo-light">
                                  <span className="logo-sm">
                                    {/*<img src={logo} alt="" height="75" />*/}
                                  </span>
                                  <span className="logo-lg">
                                    {/*<img src={logo} alt="" height="75" width="250" />*/}
                                  </span>
                                </Link>
                            </div>
                            {/*<button
                                type="button"
                                className="btn btn-sm px-3 font-size-16 d-lg-none header-item waves-effect waves-light"
                                data-toggle="collapse"
                                onClick={this.toggleMenu}
                                data-target="#topnav-menu-content">
                                <i className="fa fa-fw fa-bars"></i>
        </button>*/}
                            {/*<form className="app-search d-none d-lg-block">
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search..."
                                    />
                                    <span className="bx bx-search-alt"></span>
                                </div>
                            </form>*/}
                        </div>
                        <div className="d-flex">
                            <ProfileMenu />
                        </div>
                    </div>

                    
                </header>
        	</React.Fragment>
        )
    }
}
export default Header;